import React from "react";

//  Styles
import "./ProjectCard.scss";

const ProjectCard = props => {
    const { image, name, link, language, framework, type, description } =
        props.project;


    return (
        <div className="project" onClick={() => {link ? window.open(link, '_blank', 'noreferrer noopener') : <></>}}>
            <img src={image} alt={name} />
            <div className="project-info">
                <h1>{name}</h1>
                <p>{description}</p>
                <p>
                    <b>Language:</b> {language}
                    <br/>
                    {framework !== '' ? <><b>Framework:</b> {framework}<br/></> : ''}
                    <b>Type:</b> {type.map(t => `${t} `)}
                </p>
            </div>
        </div>
    );
};

export default ProjectCard;
